import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Card, CardContent } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Textarea } from '../../components/ui/Textarea';
import { Label } from '../../components/ui/Label';
import { RadioGroup, RadioGroupItem } from '../../components/ui/RadioGroup';
import { Badge } from '../../components/ui/Badge';
export function YouTubeCollectionNew() {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [source, setSource] = useState('channel');
  return <div className="space-y-6 max-w-2xl" data-id="element-747">
      <div data-id="element-748">
        <Button variant="ghost" size="sm" className="-ml-3 mb-2 text-muted-foreground" onClick={() => navigate('/youtube/collections')} data-id="element-749">
          <ArrowLeft className="mr-2 h-4 w-4" data-id="element-750" />
          Back
        </Button>
        <h1 className="text-3xl font-bold tracking-tight" data-id="element-751">Create collection</h1>
      </div>

      <Card data-id="element-752">
        <CardContent className="p-6 space-y-6" data-id="element-753">
          <div className="space-y-2" data-id="element-754">
            <Label htmlFor="name" data-id="element-755">Name</Label>
            <Input id="name" placeholder="e.g. Medical School Lectures" value={name} onChange={e => setName(e.target.value)} data-id="element-756" />
          </div>

          <div className="space-y-2" data-id="element-757">
            <Label htmlFor="description" data-id="element-758">Description</Label>
            <Textarea id="description" placeholder="What is this collection about?" className="resize-none h-24" data-id="element-759" />
          </div>

          <div className="space-y-3" data-id="element-760">
            <Label data-id="element-761">Source</Label>
            <RadioGroup defaultValue="channel" value={source} onValueChange={setSource} className="space-y-3" data-id="element-762">
              <div className="space-y-2" data-id="element-763">
                <div className="flex items-center space-x-2" data-id="element-764">
                  <RadioGroupItem value="channel" id="channel" data-id="element-765" />
                  <Label htmlFor="channel" className="font-normal" data-id="element-766">
                    YouTube channel (auto-sync)
                  </Label>
                </div>
                {source === 'channel' && <div className="ml-6 border bg-muted/30 p-4 mt-2 space-y-3 rounded-md" data-id="element-767">
                    <Input placeholder="Channel URL or @handle" data-id="element-768" />
                    <Button variant="ghost" size="sm" data-id="element-769">
                      Look up channel
                    </Button>
                    <p className="text-xs text-muted-foreground" data-id="element-770">
                      New videos will appear automatically as they're published.
                    </p>
                  </div>}
              </div>

              <div className="space-y-2" data-id="element-771">
                <div className="flex items-center space-x-2" data-id="element-772">
                  <RadioGroupItem value="manual" id="manual" data-id="element-773" />
                  <Label htmlFor="manual" className="font-normal" data-id="element-774">
                    Paste video URLs
                  </Label>
                </div>
                {source === 'manual' && <div className="ml-6 border bg-muted/30 p-4 mt-2 space-y-3 rounded-md" data-id="element-775">
                    <Textarea placeholder="Paste one YouTube URL per line" className="resize-none h-32" data-id="element-776" />
                    <Badge variant="secondary" data-id="element-777">0 URLs detected</Badge>
                  </div>}
              </div>

              <div className="space-y-2" data-id="element-778">
                <div className="flex items-center space-x-2" data-id="element-779">
                  <RadioGroupItem value="empty" id="empty" data-id="element-780" />
                  <Label htmlFor="empty" className="font-normal" data-id="element-781">
                    Empty (add videos later)
                  </Label>
                </div>
              </div>
            </RadioGroup>
          </div>

          <div className="flex justify-end gap-3 pt-4" data-id="element-782">
            <Button variant="outline" onClick={() => navigate('/youtube/collections')} data-id="element-783">
              Cancel
            </Button>
            <Button disabled={!name.trim()} data-id="element-784">Create collection</Button>
          </div>
        </CardContent>
      </Card>
    </div>;
}